var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.errors),function(error){return _c('v-alert',{key:error,attrs:{"type":"error"}},[_vm._v(_vm._s(error))])}),_c('AdvancedListView',{ref:"listView",attrs:{"type":_vm.field.entity_type,"scope":_vm.totalScope,"persistence":_vm.field.persistence,"options":{ title: _vm.field.label, disablePagination: true },"forms":"popup"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }